import { render, staticRenderFns } from "./BuildYourJewel.vue?vue&type=template&id=39a39178&scoped=true&"
import script from "./BuildYourJewel.vue?vue&type=script&lang=js&"
export * from "./BuildYourJewel.vue?vue&type=script&lang=js&"
import style0 from "./BuildYourJewel.vue?vue&type=style&index=0&id=39a39178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a39178",
  null
  
)

export default component.exports